import { useTableFilter } from '@welbe/web-design-system';
import Analytics from 'helpers/analytics';
import { useSessionStorage } from 'hooks/useSessionStorage';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { columns } from './Content.enums';
import { getDataCandidates } from './services';

export const useContent = ({ onUpdateTable }: { onUpdateTable: boolean }) => {
	const navigate = useNavigate();
	const { getSessionStorage } = useSessionStorage();
	const [showBusinessNames, setShowBusinessNames] = useState(false);
	const [isFilterOpen, setFilterOpen] = useState(true);
	const [isProfileButtonVisible, setProfileButtonVisible] = useState(false);

	const {
		filters,
		data,
		loading,
		totalPages,
		currentPage,
		handleSearch,
		handleFilters,
		handleChangePage,
	} = useTableFilter({
		service: getDataCandidates,
		instantSearch: [
			'doctorApprovalStatus',
			'hrApprovalStatus',
			'destinationBranchOfficeId',
			'pageSize',
			'pageNumber',
			'companyUserId',
			'customBusinessNameId',
		],
		tableFilters: {
			name: '',
			pageSize: 50,
			pageNumber: 0,
			doctorApprovalStatus: '',
			hrApprovalStatus: '',
			destinationBranchOfficeId: '',
			position: '',
		},
	});

	const handleOpenCandidate = (id: string) => {
		navigate(`/candidates/update/${id}`);
	};

	const handleOpenChat = () => {
		Analytics.track('candidate', 'Exams Banner');
		if (window.fcWidget) {
			window.fcWidget.open();
		}
	};

	const getDataListColumns = () => {
		if (!showBusinessNames) {
			return columns.filter((column) => column.id !== 'businessName');
		}

		return columns;
	};

	useEffect(() => {
		if (onUpdateTable) handleSearch();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [onUpdateTable]);

	useEffect(() => {
		const currentUser = JSON.parse(getSessionStorage('me') || '{}');
		const { company } = currentUser;
		setProfileButtonVisible(
			Boolean(
				currentUser?.company?.companyPortalSettings?.candidates
					?.showCandidateAppointmentProfile,
			),
		);

		if (company) {
			setShowBusinessNames(
				!!company.companyPortalSettings?.candidates?.showBusinessNames,
			);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return {
		isFilterOpen,
		showBusinessNames,
		isProfileButtonVisible,
		getDataListColumns,
		setFilterOpen,
		handleOpenChat,
		handleOpenCandidate,
		data,
		loading,
		totalPages,
		currentPage,
		handleSearch,
		handleFilters,
		handleChangePage,
		filters,
	};
};
